export default __webpack_public_path__ + "static/date-label-do-1-light-917a3ae84c47d57fec852f6aea0886b7e1fa13fa7365f3b18af988289d296d61.png";